import React, { Component } from 'react';
import { Container } from '@bit/ui-common.ui-components/ss-components';
import * as passwordResetServices from 'services/passwordResetServices';
import AfspLoginServices from '@bit/ui-common.ui-components/afsp/redux/services/afspLoginServices';
import * as AppServices from 'services/appService';
import { captcha } from '@bit/ui-common.ui-components/ss-common-data';
import { commonData } from '@bit/ui-common.ui-components/ss-common-data';
import ResetPasswordRequest from 'components/login/ResetPasswordRequest';
import ResetPassword from 'components/login/ResetPassword';
import ResetExpiredPassword from 'components/login/ResetExpiredPassword';
import ChangeEmail from 'components/login/ChangeEmail';
import ReactivateUser from 'components/login/ReactivateUser';
import * as accountServices from 'services/accountService';
import * as accountReducer from '../redux/reducers/accountReducer';
import { ssFormServices, ssSessionUtils, ssCommonUtils } from '@bit/ui-common.ui-components/ss-utils';

const 
{ setEnvPrefix } = ssCommonUtils,
{ htmlStorage } = ssSessionUtils;

export default Container({
    state: state => ({ state: {
        geoData: state.commonData.geoData,
        passwordReset: state.passwordReset,
        login: state.login,
        registrationForm: state.registrationForm,
        captcha: state.captcha,
        accountReactivation: state.account
    }}),
    services: [
        commonData.commonDataServices,
        captcha.captchaServices,
        passwordResetServices,
        AfspLoginServices,
        ssFormServices,
        accountServices,
        
        [
            AppServices,
            'togglePasswordUpdateView'
        ]
    ]
},
class Reset extends Component {
    constructor(props) { super(props); }
    render = () => { switch(this.props.type) {
        default: return null;
        case 'change-email': return <ChangeEmail {...this.props} />;
        case 'reset-password-request': return <ResetPasswordRequest {...this.props} />;
        case 'reset-password': return <ResetPassword {...this.props} />;
        case 'reactivate-user': return <ReactivateUser {...this.props} />;
        case 'reset-expired-password':
            if(this.props.hasOwnProperty('id') && this.props.id != null && this.props.id.length > 0)
                return <ResetExpiredPassword {...this.props} />;
            else {
                try { window.location.href = htmlStorage().get('home').path; } 
                catch { window.location.href = setEnvPrefix('/home'); }
            }
            break;
    }}
});
